/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CountyLookupDbResponseDataModelApiModel } from '../../models/county-lookup-db-response-data-model-api-model';

export interface Search$Params {
  search: any;
}

export function search(http: HttpClient, rootUrl: string, params: Search$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CountyLookupDbResponseDataModelApiModel>>> {
  const rb = new RequestBuilder(rootUrl, search.PATH, 'get');
  if (params) {
    rb.path('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<CountyLookupDbResponseDataModelApiModel>>;
    })
  );
}

search.PATH = '/v1/counties/{search}';
